import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzTypographyComponent, TranslateModule],
})
export class EmptyStateComponent {
  @Input() imageSrc = '';
  @Input() titleResource = '';
  @Input() descriptionResource = '';
}
